export const isXml = (text?: string): boolean => {
  if (!text) return false;
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/xml");
    // Check if parsing resulted in an XML error
    return !doc.querySelector("parsererror");
  } catch {
    return false;
  }
};
